import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { fetchHe } from "../services/fetch_he";
// import { userSessionID, userSession } from "../services/client-login-service";
import { useLocation, useNavigate } from "react-router-dom";
import { setMsisdn } from "../utils/global";
import FreeGames from "../components/GamesComponets/FreeGames";
import TicTacToeIntro from "../components/intros/TicTacToeIntro";
import FreeDownload from "../components/GamesComponets/FreeDownloadable";
import Carousel from "../Slider/Carousel";
import NewLeaderboard from "../components/LeaderBoard/LeaderboardNew";

const HomeBody = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    fetchHe()
      .then((response) => {
        const msisdn = response.msisdn;
        const modifiedMsisdn = "0" + msisdn.substring(2);
        setMsisdn(modifiedMsisdn);
      })
      .catch((error) => {});
    navigate("index.php");
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const Propeller_Ads = queryParams.get("Propeller_Ads");
    const Token = queryParams.get("Token");

    if (
      Propeller_Ads === "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9" &&
      Token === "KMUFsIDTnFmyG3nMiGM6H9FNFUROf3wh7SmqJp"
    ) {
      localStorage.setItem("no-msisdn", "923000748899");
      localStorage.setItem("access_token", "propeller_ads:p_ads69");
      localStorage.setItem("MSISDN", "03000748899");
      localStorage.setItem("jwt_j", Propeller_Ads);
      console.log("------------- 2");
      navigate("/home?IsFromPropeller_Ads=true&HaveToken=true");

      // http://localhost:3000/?Propeller_Ads=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9&&Token=KMUFsIDTnFmyG3nMiGM6H9FNFUROf3wh7SmqJp
    }
  }, []);

  // useEffect(() => {
  //   userSessionID().then(
  //     (userSessionID) => {
  //       localStorage.setItem("UserSessionId", userSessionID + 1);
  //       const session = {
  //         userSessionId: localStorage.getItem("UserSessionId"),
  //         sessionType: "Home",
  //       };
  //       userSession(session).then(
  //         (userSessionResponse) => {},
  //         (userSessionError) => {}
  //       );
  //     },
  //     (userSessionIdError) => {}
  //   );
  // });

  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  // };
  // const [currentImageIndex, setCurrentImageIndex] = useState(1);

  // const firstImages = (
  //   <img
  //     src="assets/images/coins.webp"
  //     alt=""
  //     style={{ height: "50px", width: "30px" }}
  //   />
  // );
  // const secondImage = (
  //   <img
  //     src="assets/images/coins.webp"
  //     alt=""
  //     style={{ height: "50px", width: "30px", marginLeft: "1px" }}
  //   />
  // );
  // const thirdImage = (
  //   <img
  //     src="assets/images/coins.webp"
  //     alt=""
  //     style={{ height: "50px", width: "30px", marginLeft: "1px" }}
  //   />
  // );
  return (
    <div>
      <section style={{ marginTop: "70px" }}>
        <Carousel />
      </section>

      <section class="game-play-section">
        <img
          class="left-img"
          src="assets/images/game-play/left-img.webp"
          alt="left-image"
        />
        <div class="container">
          <div class="row ">
            <div class="col-lg-12">
              <div class="section-heading">
                <h5 class="subtitle">The Games You Love</h5>
                <h2 class="title ">PLAY AND WIN</h2>
                <h6 class="text">Join millions of Jazz players in Pakistan.</h6>
                {/* <section className="PricePointDisclamer">
                  <strong>Only For Jazz Prepaid Customers</strong>
                  <p>You will be charged up to Rs. 10/day, including tax.</p>
                </section> */}
                <TicTacToeIntro />
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xms-6 landing-page-game">
              <div class="single-play landing-page-game-contain">
                <div class="image">
                  <img
                    src="assets/images/thumbnail16.webp"
                    alt=""
                    className="zoomable-image"
                  />
                </div>
                <div class="contant landing-page-content">
                  <a class=" pulse-button" onClick={handleClick}>
                    Play
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xms-6 landing-page-game">
              <div class="single-play landing-page-game-contain">
                <div class="image">
                  <img
                    src="assets/images/thumbnail7.webp"
                    alt=""
                    className="zoomable-image"
                  />
                </div>
                <div class="contant landing-page-content">
                  <a class=" pulse-button" onClick={handleClick}>
                    Play
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xms-6 landing-page-game">
              <div class="single-play landing-page-game-contain">
                <div class="image">
                  <img
                    src="assets/images/thumbnail3.webp"
                    alt=""
                    className="zoomable-image"
                  />
                </div>
                <div class="contant landing-page-content">
                  <a class=" pulse-button" onClick={handleClick}>
                    Play
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xms-6 landing-page-game">
              <div class="single-play landing-page-game-contain">
                <div class="image">
                  <img
                    src="assets/images/thumbnail4.webp"
                    alt=""
                    className="zoomable-image"
                  />
                </div>
                <div class="contant landing-page-content">
                  <a class=" pulse-button" onClick={handleClick}>
                    Play
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="free_Games">
        <FreeGames />
      </section>
      <section className="free_Games">
        <FreeDownload />
      </section>
      <section className="latest-arcive">
        <div className="container">
          <div className="d-flex justify-content-center">
            <div className="col-lg-6">
              <div className="leaderboardBox_Landing">
                <div className="section-heading">
                  <h2 className="title_Leader" style={{ fontSize: "36px" }}>
                    Leaderboard
                  </h2>
                </div>
                <NewLeaderboard />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="join-us-section">
        <div className="join-section-image">
          <img src="assets/images/main man.webp" alt="Join section Image" />
        </div>
        <div className="join-section-info">
          <h5 className="join-section-h5">Lots of winners everyday</h5>
          <h2 className="join-section-h2">Be one of them</h2>
          <h6 className="join-section-h6">
            Play your favourite ad free games with GAMENOW and beat the
            scoreboard{" "}
          </h6>
        </div>
        <section className="PricePointDisclamer">
          <strong>Only For Jazz Prepaid Customers</strong>
          <p>You will be charged up to Rs. 10/day, including tax.</p>
        </section>
      </section>
    </div>
  );
};

export const onPlayClick = (msisdn) => {
  HomeBody.handleOnPlayClick(msisdn);
};

export default HomeBody;
